window.openDetail = (el) => {
    var $item = $(el).closest('.event-container').find('.detail');
    if ($item.hasClass('hidden')) {
        $item.removeClass('hidden');
        $(el).removeClass('icon-right-circle');
        $(el).addClass('icon-down-circle');
    } else {
        $item.addClass('hidden');
        $(el).removeClass('icon-down-circle');
        $(el).addClass('icon-right-circle');
    }
}
